module.exports = __webpack_public_path__ + "static/media/1954e1b2-08ad-4697-b6ed-c5220a79454b.f3eb641c.png";